/** Formata data e hora no fuso local do navegador (sem forçar America/Sao_Paulo). */
export function formatPaymentPageDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
